<template>
  <w-sliding-popup ref="slidingPopup" :title="selectTitle" width="800px" @close="closePopup">
    <w-panel slot="content">
      <div slot="header-tool-right">
        <el-button size="small" @click="exportDetailHistInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
      <el-table-wrapper slot="body" ref="changeHistTable" v-loading="isLoading" :data="dataList" :total="total" :column-default="columnDefault" remote pagination
        @condition-change="loadData" :columns="detailHistColumns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
      </el-table-wrapper>
    </w-panel>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import { convertValuByUnit, convertValueForInterfaceSpeed } from '@/utils/number';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import commonAPI from '@/api/config/common';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';

export default {
  name: 'WDetailChangeHistPopup',
  props: {
    selectHistParams: Object,
  },
  data() {
    return {
      columnDefault,
      total: null,
      selectTitle: '',
      showSearchTool: false,
      numberArray: null,
      params: {
        objId: null,
        typeKey: null,
        chngGrpSeqNumber: null,
      },
      isLoading: false,
      dataList: null,
      detailHistColumns: [
        {
          prop: 'typeName',
          label: '변경타입',
          remoteProp: 'oct.type_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'beforeValue',
          label: '변경 전',
          remoteProp: 'hist.before_value',
          sortable: true,
          searchable: true,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'afterValue',
          label: '변경 후',
          remoteProp: 'hist.after_value',
          width: 300,
          sortable: true,
          searchable: true,
          formatter: this.getConvertSizeByBData,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectHistParams(params) {
      this.params.objId = params.objId;
      this.params.typeKey = params.typeKey;
      this.params.chngGrpSeqNumber = params.chngGrpSeqNumber;
      this.selectTitle = `${params.typeName} (${getDateToString(params.checkDatetime)})`;
    },
  },
  methods: {
    getNumberArray() {
      // 타임라인에서 구성정보 비교 팝업 조회 시 Tree 노드 클릭 정보를 가져올 수 없어 selectHistParams에서 먼저 값을 찾는다.
      const target = this.selectHistParams.objDefineId ? this.selectHistParams.objDefineId : this.selectedNode.obj.objDefineId;
      switch (target) {
        case 'SERVER' :
          this.numberArray = ['SVCS', 'SVMS', 'SVDS', 'SVNS', 'SVNS'];
          break;
        case 'NETINTERFACE':
        case 'NETDEVICE':
          this.numberArray = ['NISPD'];
          break;
        default : break;
      }
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.changeHistTable.clearFilter();
      this.showSearchTool = false;
    },
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    loadData() {
      if (!isNil(this.params)) {
        this.getNumberArray();
        const tableParams = this.$refs.changeHistTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
        };
        commonAPI.getDetailChangeHistList(params).then((response) => {
          if (response.data.success) {
            this.dataList = response.data.data;
            this.total = response.data.total;
          } else {
            this.dataList = [];
            this.total = 0;
          }
        });
      }
    },
    exportDetailHistInfo() {
      const me = this;
      const tableParams = this.$refs.changeHistTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const loadParams = {
        objId: me.params.objId,
        typeKey: me.params.typeKey,
        chngGrpSeqNumber: me.params.chngGrpSeqNumber,
        data: `${me.selectHistParams.typeName}_변경이력정보_`,
        ...tableParams,
      };
      commonAPI.exportDetailChangeHistList(loadParams)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    getConvertSizeByBData(row, column, value) {
      const typeKeyArr = this.numberArray;
      if (!isNil(typeKeyArr)) {
        const findKey = typeKeyArr.includes(row.typeKey);
        if (findKey && row.typeKey === 'NISPD') {
          return convertValueForInterfaceSpeed(value);
        } else if (findKey) {
          return convertValuByUnit(value, 'Byte', true, true, true);
        }
      }
      return getValueAfterCheckEmpty(value);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/components/DetailChangeHistPopup.vue